var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGrvInsider(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.8906 8.09917C20.6469 8.09917 18.4531 7.97521 18.4531 5.61983C18.4531 5.24793 18.2094 5 17.8438 5C17.4781 5 17.2344 5.24793 17.2344 5.61983C17.2344 5.86777 17.1125 8.09917 14.7969 8.09917C14.4312 8.09917 14.1875 8.34711 14.1875 8.71901C14.1875 9.09091 14.4312 9.33884 14.7969 9.33884C15.0406 9.33884 17.2344 9.46281 17.2344 11.8182C17.2344 12.1901 17.4781 12.438 17.8438 12.438C18.2094 12.438 18.4531 12.1901 18.4531 11.8182C18.4531 11.5702 18.575 9.33884 20.8906 9.33884C21.2563 9.33884 21.5 9.09091 21.5 8.71901C21.5 8.34711 21.2563 8.09917 20.8906 8.09917Z",
    fill: "#121212"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.675 12.1901L12.8469 11.6942C11.5062 11.3223 10.4094 10.3306 10.0437 8.84297L9.55625 6.98347C9.3125 5.99174 7.97187 5.99174 7.72812 6.98347L7.3625 8.84297C6.99688 10.2066 6.02187 11.3223 4.55937 11.6942L2.73125 12.1901C1.75625 12.438 1.75625 13.8017 2.73125 14.0496L4.55937 14.5455C5.9 14.9174 6.99688 15.9091 7.3625 17.3967L7.85 19.2562C8.09375 20.2479 9.43438 20.2479 9.67813 19.2562L10.1656 17.3967C10.5312 16.0331 11.5063 14.9174 12.9688 14.5455L14.7969 14.0496C15.65 13.8017 15.65 12.314 14.675 12.1901Z",
    fill: "#121212"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrvInsider);
export default __webpack_public_path__ + "static/media/grv-insider.437ae61900fec710cce642821e21f7cf.svg";
export { ForwardRef as ReactComponent };